import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationService } from '../services/configuration.service';
import { OrderEmailService } from '../services/order-email.service';

@Component({
  selector: 'app-summary-share-demo',
  templateUrl: './summary-share-demo.component.html',
  styleUrls: ['./summary-share-demo.component.scss'],
})
export class SummaryShareDemoComponent implements OnInit {
  @Input() loading = false;
  constructor(
    private configurationService: ConfigurationService,
    private translateService: TranslateService,
    private orderEmailService: OrderEmailService
  ) {}

  ngOnInit(): void {}

  get configurationId() {
    return this.configurationService.configuration.configurationId;
  }

  share() {
    let link = 'mailto:';
    const email = this.orderEmailService.getEmailAddressForOrder();
    if (email) {
      link += email;
    }
    link += `?subject=${encodeURIComponent(
      this.translateService.instant('REQUEST_QUOTE.EMAIL.SUBJECT')
    )}&body=${encodeURIComponent(
      this.translateService.instant('REQUEST_QUOTE.EMAIL.BODY').replace('[CODE]', this.configurationId)
    )}`;
    const mail = document.createElement('a');
    mail.href = link;
    mail.click();
    mail.remove();
  }
}
